/**
 * Quick add (THEME.md §7.9 Quick add, §9.4 #29; T-163), loaded with Horizon's quick add window by
 * `snippets/okt-quick-add.liquid`.
 *
 * - A pop-up inside the window, such as the size chart's (`blocks/okt-size-chart.liquid`), is a Horizon dialog inside
 *   Horizon's dialog. Each closes on Escape and on a click outside it, so one Escape, or a click beside the pop-up,
 *   closed the window too. The window's dialog stops both on their way up from a pop-up, after the pop-up has handled
 *   them: only the pop-up closes, and focus returns to its link. Other clicks bubble on, so Horizon's delegated
 *   handlers (`on:click`) still run.
 * - "View more details" (`blocks/_product-details.liquid`) follows the variant chosen in the window, as Horizon's title
 *   link does.
 */
import { StandardEvents } from '@shopify/events';

const dialog = document.querySelector('#quick-add-dialog dialog');

if (dialog instanceof HTMLDialogElement) {
  dialog.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !(event.target instanceof Element)) return;

    const popup = event.target.closest('dialog');
    if (popup !== dialog && popup?.open) event.stopPropagation();
  });

  // A click on a pop-up's own box or on its backdrop targets the pop-up's dialog element
  dialog.addEventListener('click', (event) => {
    if (event.target instanceof HTMLDialogElement && event.target !== dialog) event.stopPropagation();
  });

  dialog.addEventListener(StandardEvents.productSelect, (event) => {
    const { promise } = /** @type {Event & { promise?: Promise<any> }} */ (event);

    promise
      ?.then(({ detail }) => {
        const href = detail?.html?.querySelector('.view-product-title a')?.getAttribute('href');
        const link = dialog.querySelector('.view-more-details');
        if (href && link) link.setAttribute('href', href);
      })
      .catch((/** @type {any} */ error) => {
        if (error?.name !== 'AbortError') console.warn('[okt-quick-add] Event promise rejected:', error);
      });
  });
}
